<template>
  <div class="t-sliderbox">
    <div class="modal" v-if="show" @click="$emit('on-mask')"></div>
    <div class="sliderbox-bd" :class="[
       {'show': show},
       {'fullwidth': !autowidth},
       {'bottom': direction === 'bottom'},
       {'left': direction === 'left'},
       {'right': direction === 'right'}]">
      <slot></slot>
    </div>
  </div>
</template>
<script>
/*
   * @param show [Array] 是否显示
   * @param autowidth [Boolean] 是否自适应宽度（仅仅direction为left，right有效，默认为true,否则宽度为100%）
   * @param direction [String] 从哪个方向滑出显示left左边，right右边，bottom底部
   * @param on-mask [Function] 点击遮罩触发方法
   *
   * @example
    <t-sliderbox :show="isShowAreaDialog" direction="bottom">
       <t-selectbox @cancel="isShowAreaDialog = false" @ok="saveIntentionArea()">
         <t-selectitem :list="cityList" list-prop="name" v-model="city" @end="onSelectCity"></t-selectitem>
         <t-selectitem :list="districtList" v-model="district" list-prop="name"></t-selectitem>
       </t-selectbox>
     </t-sliderbox>
    */
export default {
  name: 'tSliderbox',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    direction: {
      type: String,
      default: 'bottom',
    },
    autowidth: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted: function () {},
  methods: {},
};

</script>
<style lang="scss">
.sliderbox-bd {
  position: fixed;
  bottom: 0;
  z-index: 800;
  height: auto;
  width: auto;
  transition: all .4s ease;
  -webkit-transition: all .4s ease;
  &.bottom {
    left: 0;
    right: 0;
    transform: translateY(100%);
    &.show {
      transform: translateY(0%);
    }
  }
  &.left {
    left: 0;
    top: 0;
    transform: translateX(-100%);
    &.fullwidth {
      right: 0;
    }
    &.show {
      transform: translateX(0%);
    }
  }
  &.right {
    right: 0;
    top: 0;
    transform: translateX(100%);
    &.fullwidth {
      left: 0;
    }
    &.show {
      transform: translateX(0%);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/sliderbox.vue